import React from 'react';
import { Skeleton, SkeletonSquare } from '@fiverr-private/feedback';
import { Center } from '@fiverr-private/layout_components';

export const PrimaryComponentSkeleton = () => (
    <Skeleton width="auto" dataTestId="primary-skeleton">
        <Center borderColor="validationError" direction="column">
            <SkeletonSquare width="100%" height="342px" maxHeight="100%" />
        </Center>
    </Skeleton>
);
